module.exports = __webpack_public_path__ + "static/media/contribute.47306c3c.png";